import { useMediaQuery, useTheme } from '@mui/material';

export const useTileDimensions = (isShowDescriptions: boolean) => {
  const theme = useTheme();
  const isSmallDisplay = useMediaQuery(theme.breakpoints.down('md'));

  // Margins that are applied to the outer wrapper
  const tileMarginX = isSmallDisplay ? 0 : 12;
  const tileMarginY = 12;

  // Image height
  const imageHeight = 200;

  // Description area height (when shown)
  const descriptionHeight = isShowDescriptions ? 62 : 0; // 30px + mt(16px) + mb(16px)

  // Bottom section with buttons
  const bottomSectionHeight = isSmallDisplay ? 56 : 34;

  // Total content height
  const contentHeight = imageHeight + descriptionHeight + bottomSectionHeight;

  // Base dimensions for the content box
  const tileHeight = contentHeight;
  const tileWidth = {
    xs: '300px',
    sm: '350px',
    md: '380px',
  };

  // For dropzone/placeholder with extra margin
  const extraMargin = 14;
  const dropzoneHeight = tileHeight;
  const dropzoneWidth = {
    xs: '300px',
    sm: '364px',
    md: '394px',
  };

  return {
    tileHeight,
    tileWidth,
    tileMarginX,
    tileMarginY,
    imageHeight,
    descriptionHeight,
    bottomSectionHeight,
    dropzoneHeight,
    dropzoneWidth,
    extraMargin,
    extraMarginCenter: extraMargin / 2,
    isSmallDisplay,
  };
};
